export default {
  pageTitle: 'Vendor Capabilities',
  cards: [
    {
      title: 'Details',
      fields: [
        {
          label: 'Pattern-making capabilities - table',
          name: 'patternMakingCapabilitiesTable',
          type: 'yes_no',
          required: true,
        },
        {
          label: 'Pattern-making capabilities - computer system',
          name: 'patternMakingCapabilitiesComputerSystem',
          type: 'yes_no',
          required: true,
        },
        {
          label: 'Sample making capabilities',
          name: 'sampleMakingCapabilities',
          type: 'yes_no',
          required: true,
        },
        {
          label: 'Baking Oven',
          name: 'bakingOven',
          type: 'yes_no',
          required: true,
        },
        {
          label: 'Heat Transferring',
          name: 'heatTransferring',
          type: 'yes_no',
          required: true,
        },
        {
          label: 'Laser Printing',
          name: 'laserPrinting',
          type: 'yes_no',
          required: true,
        },
        {
          label: 'Garment Dyeing',
          name: 'garmentDyeing',
          type: 'yes_no',
          required: true,
        },
        {
          label: 'Garment Washing',
          name: 'garmentWashing',
          type: 'yes_no',
          required: true,
        },
        {
          label: 'Design Collection',
          name: 'designCollection',
          type: 'yes_no',
          required: true,
        },
        {
          label: 'Product Development',
          name: 'productDevelopment',
          type: 'yes_no',
          required: true,
        },
        {
          label: 'Ozone',
          name: 'ozone',
          type: 'yes_no',
          required: true,
        },
        {
          label: 'Bleach washing',
          name: 'bleachWashing',
          type: 'yes_no',
          required: true,
        },
        {
          label: 'Enzyme Washing',
          name: 'enzymeWashing',
          type: 'yes_no',
          required: true,
        },
        {
          label: 'Stone / Sand Washing',
          name: 'stoneSandWashing',
          type: 'yes_no',
          required: true,
        },
        {
          label: 'Potassium Spraying',
          name: 'potassiumSpraying',
          type: 'yes_no',
          required: true,
        },
        {
          label: 'Manniquins (Dry Processing)',
          name: 'manniquinsDryProcessing',
          type: 'yes_no',
          required: true,
        },
        {
          label: 'In house fabric testing',
          name: 'inHouseFabricTesting',
          type: 'yes_no',
          required: true,
        },
        {
          label: 'Sustainable Products',
          name: 'sustainableProducts',
          type: 'yes_no',
          required: true,
        },
        {
          label: 'EDI compliant',
          name: 'ediCompliant',
          type: 'yes_no',
          required: true,
        },
        {
          label: 'Spectrophotometer',
          name: 'spectrophotometer',
          type: 'yes_no',
          required: true,
        },
        {
          label: 'Embroidery',
          name: 'embroidery',
          type: 'yes_no',
          required: true,
        },
        {
          label: 'Laser Cutting',
          name: 'laserCutting',
          type: 'yes_no',
          required: true,
        },
        {
          label: 'Screen Printing',
          name: 'screenPrinting',
          type: 'yes_no',
          required: true,
        },
      ],
    },
    {
      title: 'Textile production',
      fields: [
        {
          label: '#Rotors (OE)',
          name: 'rotors',
          type: 'text',
        },
        {
          label: '#Spindles',
          name: 'spindles',
          type: 'text',
        },
        {
          label: '#Airjet',
          name: 'airjet',
          type: 'text',
        },
        {
          label: 'Total Capacity/Mo',
          name: 'totalCapacity',
          type: 'text',
        },
        {
          label: 'Major Source of Yarn',
          name: 'majorSourceOfYarn',
          type: 'text',
        },
        {
          label: 'Comments',
          name: 'comments',
          multiline: true,
          type: 'text',
        },
      ],
    },
  ],
};
